var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconFile = function SvgIconFile(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "icon-file_svg__Capa_2",
    viewBox: "0 0 26.4 34.56"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon-file_svg__Capa_1-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.89.14H2.04a1.9 1.9 0 0 0-1.9 1.9v30.48c0 1.05.85 1.9 1.9 1.9h22.32a1.9 1.9 0 0 0 1.9-1.9v-23z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.89.27v9.25h9.24",
    fill: "#ecf2f7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.94 0H2.04C.91 0 0 .92 0 2.04v30.48c0 1.13.92 2.04 2.04 2.04h22.32c1.13 0 2.04-.92 2.04-2.04V9.47zm.08.46 8.92 8.92h-8.92zm9.11 32.06c0 .98-.79 1.77-1.77 1.77H2.04c-.98 0-1.77-.79-1.77-1.77V2.04c0-.98.79-1.77 1.77-1.77h14.71v9.39h9.38v-.09z",
    fill: "#b2b2b2"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 6.75,
    height: 2.4,
    x: 3.93,
    y: 9,
    rx: 1.2,
    ry: 1.2,
    fill: "#b2b2b2"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 17.87,
    height: 2.4,
    x: 3.93,
    y: 15.43,
    rx: 1.2,
    ry: 1.2,
    fill: "#b2b2b2"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 17.87,
    height: 2.4,
    x: 3.93,
    y: 20.24,
    rx: 1.2,
    ry: 1.2,
    fill: "#b2b2b2"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 10.62,
    height: 2.4,
    x: 3.93,
    y: 25.05,
    rx: 1.2,
    ry: 1.2,
    fill: "#b2b2b2"
  }))));
};
export default SvgIconFile;